import React from 'react';
import { Trans } from 'react-i18next';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import ErrorIcon from '@wix/da-ds/pkg/Icons/24x24/Error';
import s from './FolderCoverInfo.scss';
const FolderCoverInfo = (props)=>{
    return /* prettier-ignore */ /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        size: "medium",
        "aria-label": "premium-folder-warning-tooltip",
        usePortal: true,
        description: /*#__PURE__*/ React.createElement(Trans, {
            i18nKey: 'mediapopup.changegallectioncover.premiumFolder.warningTooltip'
        }, "This cover image will look blurry to most deviants. To fix this,", ' ', /*#__PURE__*/ React.createElement("span", {
            className: s['emphasis']
        }, "select"), " or", ' ', /*#__PURE__*/ React.createElement("span", {
            className: s['emphasis']
        }, "upload"), " a new cover image.")
    }, /*#__PURE__*/ React.createElement(ErrorIcon, {
        className: s['info-icon']
    }));
};
FolderCoverInfo.displayName = 'FolderCoverInfo';
export default FolderCoverInfo;
